"use client"

import * as React from "react"
import { KeyMetrics } from "@/components/key-metrics"
import { EVAL_DASHBOARD_KPI_STRIP_CLASS } from "@/lib/evaluation-dashboard-a11y"
import { OperationsTermSection } from "./operations/operations-term-section"
import {
  buildOperationsTermSections,
  evaluationOperationsKpiMetrics,
  getOperationsDashboardTerms,
} from "@/lib/mock/evaluation-operations"

export function EvaluationDashboardOperationsView() {
  const terms = React.useMemo(() => getOperationsDashboardTerms(), [])
  const metrics = React.useMemo(() => evaluationOperationsKpiMetrics(terms), [terms])
  const sections = React.useMemo(() => buildOperationsTermSections(), [])

  return (
    <div className="flex flex-col gap-10">
      <KeyMetrics
        variant="cards"
        size="md"
        metrics={metrics}
        showHeader={false}
        metricsSingleRow
        className={EVAL_DASHBOARD_KPI_STRIP_CLASS}
      />

      {sections.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border px-4 py-10 text-center text-sm text-muted-foreground">
          No active survey windows across your terms.
        </div>
      ) : (
        <div id="eval-operations-terms" className="flex flex-col gap-8">
          {sections.map(section => (
            <OperationsTermSection
              key={section.term.id}
              term={section.term}
              rows={section.rows}
            />
          ))}
        </div>
      )}
    </div>
  )
}
